import { ProductMatrixSectionGeneral } from '@app/components/products/ProductMatrix/ProductMatrixSectionGeneral';
import { ProductThumbnail } from '@app/components/products/ProductThumbnail';
import { getRelatedProducts } from '@app/logic/products';
import { isDefined } from '@app/utils/is';
import { isEmpty } from '@app/utils/isEmpty';
import { Order, Product } from '@typings';
import { useTranslation } from 'react-i18next';

interface Props {
  cancelledProducts: Order.Product[];
  products: Product.Full[];
}

export const CheckoutSuccessCancelledProducts = ({ cancelledProducts, products }: Props) => {
  const { t } = useTranslation(['cancelled']);

  const productsToShow = products.filter(product =>
    cancelledProducts.find(cancelledProduct => cancelledProduct.product === product.product),
  );

  if (isEmpty(productsToShow)) {
    return null;
  }

  return (
    <div className="box">
      <h3 className="mb-5 heading-3">{t('cancelled:cancelled_products_title')}</h3>
      <p className="mb-5 text-neutral-40 body-2">{t('cancelled:cancelled_products_info')}</p>
      <div className="flex w-full flex-col gap-2">
        {productsToShow.map(product => {
          const deliveryWindow = cancelledProducts.find(cancelledProduct => cancelledProduct.product === product.product)?.deliveryWindow;
          const productFullInfo = products.find(orderProduct => product.product === orderProduct.product);

          if (!isDefined(productFullInfo)) {
            return null;
          }

          const allFullProductsInfo = [productFullInfo, ...getRelatedProducts(productFullInfo)];
          const filteredVariants = allFullProductsInfo.filter(full => product.product === full.product && product.variant === full.variant);
          const cancelledItemsIds = product.items.map(item => item.item);

          const variants = filteredVariants.map(variant => {
            const cancelledItems = variant.items.filter(item => cancelledItemsIds.includes(item.item));

            return {
              ...variant,
              items: cancelledItems,
            };
          });

          if (!isDefined(deliveryWindow)) {
            return null;
          }

          return (
            <div key={`${product.product} - ${product.variant} - ${deliveryWindow}`} className="flex w-full flex-col gap-2">
              <ProductThumbnail product={product} />
              <ProductMatrixSectionGeneral variants={variants} isReadOnly showOnlyDeliveryWindows={[deliveryWindow]} showCancelled />
            </div>
          );
        })}
      </div>
    </div>
  );
};
